import {
  CallParticipant,
  CallParticipantPermitsUpdate,
  CallParticipantStatesUpdate,
  CallParticipantStatusUpdate,
  CallStatusEnum,
  CallType,
} from '@nauTypes/callType';
import {
  END_CALL,
  GET_CALL_DATA_SUCCESS,
  GET_PARTICIPANTS_SUCCESS,
  UPDATE_PARTICIPANTS_PERMITS,
  UPDATE_PARTICIPANT_STATE,
  UPDATE_PARTICIPANT_STATUS,
} from '@redux/constants/calls';
import { updateParticipantsPermits, updateParticipantsState, updateParticipantsStatus } from 'utils/call.utils';
import { ActionType, PayloadErrorType } from '../../types/reduxTypes';
import { CallPayloadType, GetCallDataPayload, RedialType } from '../actions/callActions';
import {
  CALL_ACTIVATED,
  CALL_HANDLE_INCOMING_SUCCESS,
  CALL_MINIFY,
  CALL_RECEIVE,
  CALL_REQUEST_JOIN,
  CALL_START,
  CALL_TERMINATE,
} from '../constants';

const initialState: CallType = {
  callParticipants: [],
  caller: null,
  conference: false,
  dialogId: null,
  isWaitingInLobby: false,
  minified: false,
  status: CallStatusEnum.finish,
};

export default (
  state = initialState,
  action: ActionType<
    | GetCallDataPayload
    | CallPayloadType
    | RedialType
    | CallParticipant[]
    | CallParticipantStatusUpdate
    | CallParticipantPermitsUpdate
    | CallParticipantStatesUpdate
    | PayloadErrorType
  >
): CallType => {
  switch (action.type) {
    case CALL_START: {
      const { caller, conference, dialogId } = action.payload as CallPayloadType;
      return { ...state, caller, conference, dialogId, status: CallStatusEnum.calling };
    }
    case CALL_RECEIVE: {
      const { caller, conference, dialogId } = action.payload as CallPayloadType;
      return { ...state, caller, conference, dialogId, status: CallStatusEnum.received };
    }
    case CALL_HANDLE_INCOMING_SUCCESS: {
      const { caller, conference, dialogId } = action.payload as CallPayloadType;
      return { ...state, caller, conference, dialogId, status: CallStatusEnum.ring };
    }
    case CALL_ACTIVATED: {
      if (state.status === CallStatusEnum.calling) return { ...state, status: CallStatusEnum.received };
      if (state.isWaitingInLobby) return { ...state, isWaitingInLobby: false, status: CallStatusEnum.received };
      return { ...state };
    }
    case CALL_TERMINATE: {
      return initialState;
    }
    case CALL_REQUEST_JOIN: {
      const { caller, conference, dialogId } = action.payload as CallPayloadType;
      return { ...state, caller, conference, dialogId, isWaitingInLobby: true };
    }
    case END_CALL: {
      return initialState;
    }
    case CALL_MINIFY: {
      return { ...state, minified: action.payload as unknown as boolean };
    }
    case GET_PARTICIPANTS_SUCCESS: {
      return { ...state, callParticipants: action.payload as CallParticipant[] };
    }
    case GET_CALL_DATA_SUCCESS: {
      const callData = action.payload as GetCallDataPayload;
      return { ...state, ...callData };
    }
    case UPDATE_PARTICIPANT_STATUS: {
      const updates = action.payload as CallParticipantStatusUpdate;
      const updatedParticipants = updateParticipantsStatus(state.callParticipants, updates);
      return { ...state, callParticipants: updatedParticipants };
    }
    case UPDATE_PARTICIPANTS_PERMITS: {
      const changes = action.payload as CallParticipantPermitsUpdate;
      const updatedParticipants = updateParticipantsPermits({ changes, participants: state.callParticipants });
      return { ...state, callParticipants: updatedParticipants };
    }
    case UPDATE_PARTICIPANT_STATE: {
      const updates = action.payload as CallParticipantStatesUpdate;
      const updatedParticipants = updateParticipantsState({ participants: state.callParticipants, updates });
      return { ...state, callParticipants: updatedParticipants };
    }

    default: {
      return state;
    }
  }
};
